import { observer, useLocalObservable } from "mobx-react";
import Draggable from "react-draggable";
import { Tooltip } from "antd";
import { OFTableController } from "../OFTableController";

const RenderHeaderCell = observer(
  ({
    ofTableController,
    column,
    columnIndex,
  }: {
    ofTableController: OFTableController;
    column: any;
    columnIndex: number;
  }) => {
    const state = useLocalObservable(() => ({
      get sortIndication() {
        const showSortIndicator = ofTableController.sortBy === column.id;

        let sortClass = "";

        if (showSortIndicator) {
          if ("desc" === ofTableController.sortDirection) {
            sortClass += " -sort-desc";
          } else {
            sortClass += " -sort-asc";
          }
        }

        return sortClass;
      },

      get getOffset() {
        const { visibleColumns, fixedColumns } = ofTableController;

        let totalOffset = 0;
        let fixedOffset = 0;

        visibleColumns.forEach((col, index) => {
          if (col.subColumns) {
            col.subColumns.forEach((subCol, subIndex) => {
              if (fixedColumns < subIndex + 1 && subIndex <= columnIndex) {
                totalOffset += subCol.width;
              }
              if (fixedColumns >= subIndex + 1 && subIndex < columnIndex) {
                fixedOffset += subCol.width;
              }
            });
          } else {
            if (fixedColumns < index + 1 && index <= columnIndex) {
              totalOffset += col.width;
            }

            if (fixedColumns >= index + 1 && index < columnIndex) {
              fixedOffset += col.width;
            }
          }
        });

        if (fixedColumns >= columnIndex + 1) {
          return fixedOffset;
        } else {
          return totalOffset;
        }
      },
    }));

    if (column.id === "OFTable_lastCol" && column.width === 0) {
      return null;
    }

    let isFixed = false;
    let className = "";
    const offset = state.getOffset;

    if (ofTableController.fixedColumns >= columnIndex + 1) {
      isFixed = true;
      className += "fixedHeader";
    } else if (offset < ofTableController.offsetLeft) {
      return <div style={{ width: column.width }} />;
    }

    if (offset - column.width > ofTableController.tableWidth + ofTableController.offsetLeft) {
      return null;
    }

    if (ofTableController.fixedColumns === columnIndex + 1) {
      className += " lastFixed";
    }

    // console.log('-------------------------------------------------------------')
    // console.log(column)
    return (
      <div className={className} style={{ width: column.width, left: isFixed ? offset : "unset" }}>
        <div className="flex flex-col w-full tableColumn">
          <div className={"flex flex-row justify-between w-full headerTitle" + state.sortIndication} key={column.id}>
            {typeof column.Header === "string" ? (
              <Tooltip title={column.Header} align={{ offset: [0, 5] }} mouseLeaveDelay={0}>
                <div
                  className="text-center w-full self-center"
                  style={{ padding: 5 }}
                  onClick={() => ofTableController.handleSorting(column.id)}
                >
                  {column.Header}
                </div>
              </Tooltip>
            ) : (
              <div
                className="text-center w-full self-center"
                style={{ padding: 5 }}
                onClick={() => ofTableController.handleSorting(column.id)}
              >
                {typeof column.Header === "function" ? column.Header() : column.Header}
              </div>
            )}
            {!column.disableResizing && (
              <Draggable
                axis="x"
                defaultClassName="DragHandle"
                defaultClassNameDragging="DragHandleActive"
                onDrag={(event, { deltaX }) => {
                  // Do not change the width if its below 35px
                  if (column.width + deltaX > 35) {
                    ofTableController.resizeRow(column, { deltaX }, event);
                  }
                }}
                onStop={(event, { deltaX }) => ofTableController.resizeRow(column, { deltaX }, event, true)}
                position={{ x: 0, y: undefined }}
              >
                <div onClick={ofTableController.killClick} className="resizer" />
              </Draggable>
            )}
          </div>
          {ofTableController.isFilterVisible && (
            <div onClick={ofTableController.killClick} className="tableFilter">
              {!column.disableFilters && ofTableController.renderFilterComponent(column)}
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default RenderHeaderCell;
